import { env } from '@config/env';
import { useBrandingStore } from '@shared/stores/brandingStore';

/**
 * Full-screen loading overlay shown while the app resolves tenant branding
 * on a cold start — used by the welcome screen to hold back its first paint
 * until the tenant's imagery + colours are known.
 *
 * When the build configures `env.loaderImage` that asset (an SVG, ideally
 * self-animated) is shown on its own. Otherwise the resolved tenant logo is
 * shown above a neutral branded spinner.
 */
export function BrandLoader(): JSX.Element {
  const branding = useBrandingStore((s) => s.branding);

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-7 bg-paper">
      {env.loaderImage ? (
        <img src={env.loaderImage} alt="" className="h-28 w-28 object-contain" />
      ) : (
        <>
          {branding?.logoUrl ? (
            <img
              src={branding.logoUrl}
              alt={branding.name ?? ''}
              className="h-11 w-auto max-w-[55%] object-contain"
            />
          ) : null}
          <span
            aria-label="Loading"
            role="status"
            className="h-7 w-7 animate-spin rounded-pill border-2 border-hairline border-t-primary-600"
          />
        </>
      )}
    </div>
  );
}
